import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from "@shop-builder/core/widget";
import { BasketAssistant } from "@api/services/basket";
import config from "@api/config";
import { TrackingCheckout } from "@api/services/tracking";
var ShoppingCartWidget = /*@__PURE__*/ (function () {
    function ShoppingCartWidget() {
    }
    ShoppingCartWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.onBasketUpdate = this.onBasketUpdate.bind(this);
                BasketAssistant.subscribe("itemsAdded", this.onBasketUpdate);
                BasketAssistant.subscribe("itemsDeleted", this.onBasketUpdate);
                BasketAssistant.subscribe("lastModified", this.onBasketUpdate);
                this.loadBasketItems();
                this.overrideEventListener();
                if (window.sessionStorage.getItem("vfOrderId")) {
                    this.setLegiUploadLink();
                    this.confirmationTracking();
                }
                return [2 /*return*/];
            });
        });
    };
    ShoppingCartWidget.prototype.onBasketUpdate = function (basket) {
        this.updateAmount();
    };
    ShoppingCartWidget.prototype.loadBasketItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        if (Object.keys(items).length > 0) {
                            this.updateAmount();
                            this.show();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ShoppingCartWidget.prototype.show = function () {
        var counter = this.getElement().querySelector(".counter");
        counter.style.display = "block";
    };
    ShoppingCartWidget.prototype.hide = function () {
        var counter = this.getElement().querySelector(".counter");
        counter.style.display = "none";
    };
    ShoppingCartWidget.prototype.updateAmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items, amount, item, counter;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.getItems()];
                    case 1:
                        items = _a.sent();
                        amount = 0;
                        for (item in items) {
                            amount += items[item].amount;
                        }
                        if (amount > 0) {
                            this.show();
                        }
                        else {
                            this.hide();
                            return [2 /*return*/];
                        }
                        counter = this.getElement().querySelector(".counter");
                        counter.innerHTML = amount;
                        clearTimeout(this.animationTimeout);
                        this.animationTimeout = setTimeout(function () {
                            jQuery(counter).addClass("bounce");
                            clearTimeout(_this.animationTimeout);
                            _this.animationTimeout = setTimeout(function () {
                                jQuery(counter).removeClass("bounce");
                            }, 1200);
                        }, 10);
                        return [2 /*return*/];
                }
            });
        });
    };
    ShoppingCartWidget.prototype.overrideEventListener = function () {
        jQuery(this.getElement())
            .off()
            .on("click", function (e) {
            e.preventDefault();
            window.location.href = config.BASKET_PAGE_URL;
        });
    };
    ShoppingCartWidget.prototype.confirmationTracking = function () {
        return __awaiter(this, void 0, void 0, function () {
            var initialTracking;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initialTracking = new TrackingCheckout();
                        return [4 /*yield*/, initialTracking
                                .setStep("4")
                                .setName("confirmation")
                                .setPageType("confirmation")
                                .setStatus(["end", "success"])
                                .setOrderId(window.sessionStorage.getItem("vfOrderId"))
                                .setNumberPortability(window.sessionStorage.getItem("numberPortability"))
                                .setShippingMethod("home")
                                .setShippingPrice("0.0")
                                .setPaymentMethodOnce("credit")
                                .setPaymentMethodRecurring("credit")
                                .track()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, BasketAssistant.removeAllItems(true)];
                    case 2:
                        _a.sent();
                        window.sessionStorage.removeItem("vfOrderId");
                        window.sessionStorage.removeItem("vfOrderNumberPortability");
                        return [2 /*return*/];
                }
            });
        });
    };
    ShoppingCartWidget.prototype.setLegiUploadLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            var vfOrderId, legiLink, jsonObject, encodedOrderId;
            return __generator(this, function (_a) {
                vfOrderId = window.sessionStorage.getItem("vfOrderId");
                legiLink = document.querySelector(".ep-shop-legi-upload-link");
                if (legiLink && vfOrderId) {
                    jsonObject = {
                        orderNo: vfOrderId,
                    };
                    encodedOrderId = btoa(JSON.stringify(jsonObject));
                    legiLink.setAttribute("href", config.CHECKOUT_UPLOAD_URL + "?" + encodedOrderId);
                }
                else if (legiLink && !vfOrderId) {
                    legiLink.removeAttribute("href");
                }
                return [2 /*return*/];
            });
        });
    };
    ShoppingCartWidget = __decorate([
        Widget({
            selector: ".nav-item-main-right.item-basket",
            name: "shopping-cart",
        })
    ], ShoppingCartWidget);
    return ShoppingCartWidget;
}());
export { ShoppingCartWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/shopping-cart/shopping-cart.ts
// module id = null
// module chunks = 